import { movedToV3Async } from './notification';

// ── readOnly.ts — Titan Secure v2 read only (BLOCKED_FOR_V3=yes) ──
// The developer, 20 Oct 2026: block every mutative function of v2's admin dashboard and point to v3's admin. Set like every
// appsettings value, by the container's public_ variable: public_BLOCKED_FOR_V3=yes (docker-start.js writes it to
// appsettings.json as BLOCKED_FOR_V3). Every write is refused with a popup linking to v3's admin: each API call that is not a
// read (the axios interceptor in index.tsx), each Firestore write (useCollection), each company change (fetch) and each
// password change made from this app. Signing in and out stay open.

export const READ_ONLY_MESSAGE = 'Titan Secure v2 is read only - changes are made in Titan Secure v3';

const READ_METHODS = ['get', 'head', 'options'];

let readOnly = false;

export function isBlockedForV3(settings: any): boolean {
  return `${settings?.BLOCKED_FOR_V3 ?? ''}`.trim().toLowerCase() === 'yes';
}

export function setReadOnly(value: boolean): void {
  readOnly = value;
}

export function isReadOnly(): boolean {
  return readOnly;
}

export function isMutativeMethod(method?: string): boolean {
  return !READ_METHODS.includes(`${method ?? 'get'}`.toLowerCase());
}

// the popup first, then the refusal - the caller's own error handling runs once the popup is closed

export async function refuseWriteAsync(): Promise<never> {
  await movedToV3Async();

  throw new Error(READ_ONLY_MESSAGE);
}

export async function refuseWriteWhenReadOnlyAsync(): Promise<void> {
  if (readOnly) {
    await refuseWriteAsync();
  }
}
